import React, { useState } from 'react';
import { connect } from 'react-redux';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import { CardReadersList } from 'components/pos/CardReadersList.component';
import POS_READER_STATUS from 'constants/pos/posReaderStatus.const';
import useResettingState from 'hooks/useResettingState.hook';
import { useTranslation } from 'providers/GILT.provider';
import { selectUserStylistId } from 'selectors/simple';
import { firstOf } from 'utils/arrays/elements.util';
import noNilArray from 'utils/arrays/noNilArray.util';
import sortById from 'utils/arrays/sortById.util';
import call from 'utils/functions/call.util';
import { isValidId } from 'utils/predicates/fields.util';
import { concatTag as ct } from 'utils/strings/manipulate.util';

import CN from './CardReadersModal.module.scss';

const CardReadersModal = ({ isOpen, onClose, onSelect, onNonSlickSelect, isLoading, readers, generalReaderStatus, stylistId, tag }) => {
  const { t } = useTranslation();

  const sortedReaders = [...noNilArray(readers)].sort(sortById);
  const onlineReaders = sortedReaders.filter((reader) => POS_READER_STATUS.online === reader.status);
  const hasValidUserStylistId = isValidId(stylistId);

  const [value, setValue] = useResettingState(
    onlineReaders.find((r) => hasValidUserStylistId && isValidId(r?.stylistId) && r?.stylistId === stylistId) ?? onlineReaders.find((r) => r.isMain) ?? firstOf(onlineReaders),
  );

  const [isNonSlickSelected, setIsNonSlickSelected] = useState(false);

  const handleSelectReader = (reader) => {
    setIsNonSlickSelected(false);
    setValue(reader);
  };

  const handleSelectNonSlick = () => {
    setIsNonSlickSelected(true);
    setValue(null);
  };
  const handleNext = () => {
    if (isNonSlickSelected) {
      void call('CardReadersModal.onNonSlickSelect', onNonSlickSelect);
    } else {
      void call('CardReadersModal.onSelect', onSelect, { value });
    }
  };
  const handleClose = () => void call('CardReadersModal.onClose', onClose, { value: null });

  return (
    <SalonModal tag={ct('CardReadersModal', tag)} isOpen={isOpen} withFooter banner="backgroundImageWave">
      <SalonModal.Header>
        <div className={CN.modalHeader}>
          <div className={CN.modalHeaderTitle}>{t('composite.cardReaderModal.title')}</div>

          <div className={CN.closeModalButton}>
            <Button tag="CardReadersModal__close" variant="empty" onClick={handleClose}>
              <Icon variant="close" />
            </Button>
          </div>
        </div>
      </SalonModal.Header>
      <SalonModal.Body>
        <CardReadersList
          value={value}
          onSelect={handleSelectReader}
          isNonSlickSelected={isNonSlickSelected}
          onNonSlickSelect={handleSelectNonSlick}
          isLoading={isLoading}
          readers={readers}
          generalReaderStatus={generalReaderStatus}
        />
      </SalonModal.Body>
      <SalonModal.Footer>
        <Button tag="CardReadersModal__button-next" variant="primary" disabled={!value && !isNonSlickSelected} onClick={handleNext}>
          {t('common.buttons.next')}
        </Button>
      </SalonModal.Footer>
    </SalonModal>
  );
};

const CardReadersModalHoc = connect((state) => ({
  stylistId: selectUserStylistId(state),
}))(CardReadersModal);

export default CardReadersModalHoc;
